import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vilka dokument krävs i ansökan om serveringstillstånd?";
const SHORT_ANSWER = "Registreringsbevis, finansieringsplan, hyresavtal, ritning, brandskyddsdokumentation, livsmedelsregistrering, anmälan av serveringsansvariga och meny/verksamhetsbeskrivning.";

export const Route = createFileRoute("/fraga/vilka-dokument-kravs")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vilka dokument krävs i ansökan om serveringstil…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Kommunen begär normalt: ansökningsblankett, bolagsbevis från Bolagsverket (max 3 mån), uppgift om PBI-krets, finansieringsplan, hyresavtal/dispositionsrätt, ritning över serveringsyta inkl. uteservering, brandskyddsdokumentation, livsmedelsanmälan, anmälan av serveringsansvariga, meny och kassaregisterbevis."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/ansoka-om-alkoholtillstand", label: "Ansökningsguide – steg för steg" }}
      related={[{"to": "/fraga/behover-jag-eget-kok-2026", "label": "Behöver jag eget kök 2026 för att få serveringstillstånd?"}, {"to": "/fraga/far-jag-servera-utan-mat", "label": "Får jag servera alkohol utan att servera mat 2026?"}, {"to": "/fraga/hur-lang-handlaggningstid", "label": "Hur lång är handläggningstiden för serveringstillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vilka dokument krävs i ansökan om serveringstillstånd?" },
      { name: "description", content: "Registreringsbevis, finansieringsplan, hyresavtal, ritning, brandskyddsdokumentation, livsmedelsregistrering, anmälan av serveringsansvariga och meny/verksam…" },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vilka-dokument-kravs" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vilka-dokument-kravs" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vilka-dokument-kravs",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vilka dokument krävs i ansökan om serveringstil…", url: "https://alkoholprovet.se/fraga/vilka-dokument-kravs" },
      ]),
    ],
  }),
});
